<template>
  <div class="upper-subpanel--inside">
    <div class="col-6">
      <DrugInfo/>
    </div>
    <div class="col-6">
      <ConfirmFlow 
        v-if="currentProgress === 'confirm'"
        v-on:confirmationFinish="getConfirmData"
        :startActionType="startActionType"
        :confirmProgress="confirmProgress"
        :actionProgress="actionProgress"
        :barcodeData="barcodeData">
      </ConfirmFlow>  
      <Loader v-if="currentProgress === 'finish'" />  
    </div>
  </div>
</template>

<script>
import MultiFlowBase from '../ComponentBase/MultiFlowBase';
import DrugInfo from '../flowComp/DrugInfo';
import ConfirmFlow from './ConfirmFlow';
import Loader from '../common/Loader';

export default {
  name: 'multiFlow',
  extends: MultiFlowBase,
  props: ['barcodeData', 'startActionType'],
  data() {
    return {
      checkFun: undefined,
    };
  },
  components: {
    DrugInfo,
    ConfirmFlow,
    Loader,
  },
  created() {
    this.$store.commit('SET_CURRENT_STEP', 'setFetchNum');
  },
  methods: {
    getConfirmData() {
      this.nextProgress();
      this.checkFun = setInterval(() => {
        this.checkDevicesCloseAndEmit();
      }, 500);
    },
    nextStep() {
      // Multi fetch drug function is now disabled.
      if (this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex < (this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length) - 1) {
        console.log('get confirm data, move to next');
        this.$store.dispatch('toNextDrugInDevice');
        this.resetProgress();
      } else {
        console.log('leave multiflow, finish workflow');
        this.$emit('setAllConfirmData');
      }
    },
    //20190412 modified by aaron
    checkDevicesCloseAndEmit() {
      if (this.nextDevice) {
        if (this.nextDevice.net.id === this.currentDevice.net.id && this.errorDevices.length > 1) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒',
          });
        } else if (this.nextDevice.net.id !== this.currentDevice.net.id && this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜',
          });
        } else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      } else {
        /*
        this.$store.commit('CLOSE_MESSAGE');
        if (this.checkFun) {
          clearInterval(this.checkFun);
        }
        this.nextStep();
        */
        if (this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜',
          });
        } 
        else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      }
    },
  },
  computed: {
    selectedDrugInDevice() {
      return this.$store.state.drugInDevice.selectedDrugInDevice;
    },
  },
};
</script>



// WEBPACK FOOTER //
// MultiFlow.vue?37f6ad8c